import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationTechnicalMessageActions = {
  GET_ITEM_DETAILS: 'get_item_details',
} as const

export type ConversationTechnicalMessageActionEnum = Enum<
  typeof ConversationTechnicalMessageActions
>
